import styled, { css } from 'styled-components'

import { down } from 'styled-breakpoints'

export const FileDetailsStyles = {
  Content: styled.div`
    flex-direction: column;
  `,
}

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  padding: 25px;
  overflow: auto;
`

export const Container = styled.div<{ open: boolean }>`
  position: absolute;
  height: 80vh;
  border-radius: 20px 0px 0px 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: -8px 0px 32px 0px rgba(0, 0, 0, 0.1);
  width: 425px;
  flex-direction: column;
  transition: right 0.4s cubic-bezier(0.36, -0.01, 0, 0.77);
  overflow: hidden;
  top: 50px;
  display: flex;
  z-index: 100;
  flex-direction: column;
  gap: 10px;

  ${down('md')} {
    width: 100%;
    top: 0px;
    height: 100%;
    border-radius: 0px;
  }
  ${({ open }) =>
    open
      ? css`
          right: -0px;
        `
      : css`
          right: -100%;
        `}
`
